import type { HeadingProps } from './types';
import React from 'react';
import { Styled } from './index.styles';

export const Heading: React.FC<HeadingProps> = ({
  children,
  ellipsis = false,
  noMargin = false,
  variant,
  ...props
}) => (
  <Styled.Heading
    $ellipsis={ellipsis}
    $noMargin={noMargin}
    $variant={variant}
    as={variant}
    {...props}
  >
    {children}
  </Styled.Heading>
);
